import { Main } from "layouts/Main/Main";

export default Main;
